import { render } from "./WelcomeQuickNav.vue?vue&type=template&id=51d00a6c&scoped=true"
import script from "./WelcomeQuickNav.vue?vue&type=script&lang=js"
export * from "./WelcomeQuickNav.vue?vue&type=script&lang=js"

import "./WelcomeQuickNav.vue?vue&type=style&index=0&id=51d00a6c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d00a6c"]])

export default __exports__